import axios from "axios";
import { removeCookies } from "./helpers";

const URL_API = import.meta.env.VITE_API_BASE_URL || ""
let store

export const injectStore = _store => {
  store = _store
}

const instance = axios.create({
  baseURL: URL_API,
  headers: {
    "Content-Type": "application/json",
    "Authorization": ""
  },
  timeout: 60000,
})

instance.interceptors.request.use(
  (cfg) => {
    const { auth } = store.getState()

    if (auth.token && cfg.useToken) {
      if (!auth.user) {
        removeCookies()

        window.location.replace("/auth/login");
      }

      cfg.headers.Authorization = `Bearer ${auth.token}`
    }
    if (cfg.useApiKey) cfg.headers["X-CSCAPI-KEY"] = import.meta.env.VITE_X_CSCAPI_KEY

    return cfg
  }, () => {
    return Promise.reject(err)
  })

// Add a response interceptor
instance.interceptors.response.use(
  (res) => {
    return res
  }, (err) => {
    if (err.status == 401) {
      removeCookies()

      window.location.replace("/auth/login");
    }
    if (err.status == 500) {
      window.location.replace("/page-not-found");
    }    

    return Promise.reject(err)
  }
)

export default instance
